(function () {
  'use strict';

  function initialiseLanguageSelectors() {
    document.querySelectorAll('[data-language-switcher]').forEach(function (switcher) {
      if (switcher.dataset.languageSwitcherReady === 'true') return;
      switcher.dataset.languageSwitcherReady = 'true';

      var form = switcher.closest('form');
      var trigger = switcher.querySelector('[data-language-trigger]');
      var menu = switcher.querySelector('[data-language-menu]');
      var select = switcher.querySelector('[data-language-select]');

      function closeMenu() {
        if (!trigger || !menu) return;
        menu.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
      }

      function toggleMenu() {
        if (!trigger || !menu) return;
        var shouldOpen = menu.hidden;
        menu.hidden = !shouldOpen;
        trigger.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
        if (shouldOpen) {
          var selected = menu.querySelector('.is-selected');
          if (selected) selected.focus();
        }
      }

      if (trigger && menu) {
        trigger.addEventListener('click', function (event) {
          event.preventDefault();
          toggleMenu();
        });
      }

      switcher.querySelectorAll('[data-language-option]').forEach(function (option) {
        option.addEventListener('click', function () {
          var nextLanguage = option.getAttribute('data-language-code') || '';
          if (!select || !form || !nextLanguage) return;
          if (select.value === nextLanguage) {
            closeMenu();
            if (trigger) trigger.focus();
            return;
          }
          select.value = nextLanguage;
          form.submit();
        });
      });

      document.addEventListener('click', function (event) {
        if (!switcher.contains(event.target)) closeMenu();
      });
      document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape' || !menu || menu.hidden) return;
        closeMenu();
        if (trigger) trigger.focus();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseLanguageSelectors, { once: true });
  } else {
    initialiseLanguageSelectors();
  }
})();
